import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllUsers, toggleUserStatus } from "../../store/thunk/adminUser";

function AllUsers(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const allUsers = useSelector((store) => store.user.allUsers);
    const [togglingId, setTogglingId] = useState(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (props.userId) {
            dispatch(getAllUsers(props.userId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleToggle = async (userId, currentStatus) => {
        setTogglingId(userId);
        await dispatch(toggleUserStatus({ userId, isActive: !currentStatus }));
        setTogglingId(null);
    };

    return (
        <div className="col-lg-8 col-md-8 col-12">
            <div className="ml-0 ml-md-4">
                <div className="d-none d-md-block">
                    <div className="row mb-md-5">
                        <div className="col">
                            <h5 className="mb-1 text-white">All Users</h5>
                            <p className="mb-0 text-white small">
                                Manage user accounts — activate or disable access.
                            </p>
                        </div>
                        <div className="col-auto">
                            <button className="btn btn-primary btn-sm" onClick={() => navigate(-1)}>
                                <i className="ti-angle-left"></i> Go Back
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="table-responsive">
                        <table className="table mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allUsers && allUsers.length > 0 && allUsers.map((user, index) => (
                                    <tr key={user.id}>
                                        <td className="py-3">{index + 1}</td>
                                        <td className="py-3">{user.firstName + ' ' + user.lastName}</td>
                                        <td className="py-3">{user.email}</td>
                                        <td className="py-3">{user.phone}</td>
                                        <td className="py-3">
                                            <span className={`badge ${user.isActive ? 'bg-success' : 'bg-danger'}`}>
                                                {user.isActive ? 'Active' : 'Disabled'}
                                            </span>
                                        </td>
                                        <td className="py-3">
                                            <button
                                                className={`btn btn-sm ${user.isActive ? 'btn-outline-danger' : 'btn-outline-success'}`}
                                                disabled={togglingId === user.id}
                                                onClick={() => handleToggle(user.id, user.isActive)}
                                            >
                                                {togglingId === user.id
                                                    ? '...'
                                                    : user.isActive ? 'Disable' : 'Activate'}
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AllUsers;
